import { render, staticRenderFns } from "./productAlerts.vue?vue&type=template&id=542c5ec2"
import script from "./productAlerts.vue?vue&type=script&lang=js"
export * from "./productAlerts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports